import React from 'react';
import RecoverPassword from '../../components/RecoverPassword';

export default function RecoverPage() {
  return <RecoverPassword />;
}
